import { render, staticRenderFns } from "./EditSurveyStageExpandTemplate.vue?vue&type=template&id=2c55e0e2&scoped=true"
import script from "./EditSurveyStageExpandTemplate.vue?vue&type=script&lang=js"
export * from "./EditSurveyStageExpandTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c55e0e2",
  null
  
)

export default component.exports